import actionTypes from '../actionTypes'
const defaultState = {
    producerFlowId: '',
    producerFlow: {},
    sourceDataList: [],
    searchRules02: ''
}

const flowReducer = (state = defaultState, action) => {
    switch (action.type) {
        case actionTypes.defaultState:
            return defaultState;
        case actionTypes.SetProducerFlowId:
            return Object.assign({}, state, action);
        case actionTypes.SetProducerFlow:
            return Object.assign({}, state, action);
        case actionTypes.SetSourceDataList:
            return Object.assign({}, state, action);
        case actionTypes.searchRules02:
            return Object.assign({}, state, action);
        default:
            return state;
    }
}
export default flowReducer